import {createContext} from "react";
const uiContext=createContext();
export default uiContext;